const Start = (state = { recaptchaKey: localStorage.getItem("recaptchaKey"), scrollToError: false }, action) => {
  switch (action.type) {
    case 'GET_START_PARAM':
      return state
    case 'SET_START_PARAM':
      state = action.payload;
      return state
    case 'SET_RECAPTCHA_KEY':
      localStorage.setItem("recaptchaKey", action.payload);
      return {
        ...state,
        recaptchaKey: localStorage.getItem("recaptchaKey")
      }
    case 'GET_RECAPTCHA_KEY':
      return state.recaptchaKey;
    case "SCROLL_TO_ERROR":
      return {
        ...state,
        scrollToError: action.payload
      }
    default:
      return state
  }
}
export default Start
